import url_servidor_mapas from './entorno.js';


export default class WMS {
  _capa;
  _filtro;

  constructor(capa) {
    this._capa = capa;
  }

  get filtro() {
    return this._filtro;
  }
  set filtro(cql) {
    this._filtro = cql;
  }

  get espacioDeTrabajo() {
    return this._capa.includes(':')? this._capa.split(':')[0] : '';
  }

  get url() {
    return `${url_servidor_mapas}${this.espacioDeTrabajo}/wms?`
  }

  get _parametrosGeoserver() {
    return {
      LAYERS: this._capa,
      cql_filter: this._filtro,
    };
  }

  get parametros() {
    return Object.fromEntries(Object.entries(this._parametrosGeoserver)
      .filter(([, valor]) => valor!=undefined));
  }
}

export function generarUrl(layer) {
  // Separar espacio de trabajo de geoserver
  const espacioDeTrabajo = layer.includes(':')? `${layer.split(':')[0]}/` : ''
  // Concatenar url
  return `${url_servidor_mapas}${espacioDeTrabajo}wms?`
}